/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import api from "@/lib/api";

const GIORNI = {1:"Lunedì",2:"Martedì",3:"Mercoledì",4:"Giovedì",5:"Venerdì",6:"Sabato",7:"Domenica"};

const STATO_STYLE = {
  ricevuta: { bg: "#fff8e1", border: "#ffa726", color: "#bf360c", label: "📥 Ricevuta" },
  accettata: { bg: "#e8f5e9", border: "#4caf50", color: "#1b5e20", label: "✅ Accettata" },
  rifiutata: { bg: "#ffebee", border: "#ef5350", color: "#b71c1c", label: "❌ Rifiutata" },
};

export default function SpotRichiesteAdminView() {
  const [items, setItems] = useState([]);
  const [filterStato, setFilterStato] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // { rid, esito, preview }
  const [creaModalOpen, setCreaModalOpen] = useState(false);
  const [giorniModal, setGiorniModal] = useState(null); // { it, giorni:Set }
  const [selected, setSelected] = useState(new Set()); // Set<id> richieste spuntate
  const [bulkOpen, setBulkOpen] = useState(false);

  const toggleSel = (id) => setSelected(prev => {
    const ns = new Set(prev);
    ns.has(id) ? ns.delete(id) : ns.add(id);
    return ns;
  });

  const salvaGiorni = async () => {
    if (!giorniModal || giorniModal.giorni.size === 0) { alert("Seleziona almeno un giorno."); return; }
    try {
      await api.put(`/mensa-matrice/spot/admin/${giorniModal.it.id}/giorni`, { giorni: Array.from(giorniModal.giorni) });
      setGiorniModal(null);
      await load();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore salvataggio giorni");
    }
  };

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/mensa-matrice/spot/admin/list", { params: filterStato ? { stato: filterStato } : {} });
      setItems(r.data.items || []);
    } catch (e) {
      alert(e.response?.data?.detail || "Errore caricamento");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [filterStato]);

  const s = search.trim().toLowerCase();
  const filteredItems = s
    ? items.filter(it => `${it.cognome || ""} ${it.nome || ""} ${it.classe || ""} ${it.alunno_cod || ""}`.toLowerCase().includes(s))
    : items;

  const counts = { ricevuta: 0, accettata: 0, rifiutata: 0 };
  for (const it of items) { if (counts[it.stato] != null) counts[it.stato]++; }

  const visibleIds = filteredItems.map(it => it.id);
  const selectedVisible = visibleIds.filter(id => selected.has(id));
  const allVisibleSelected = visibleIds.length > 0 && selectedVisible.length === visibleIds.length;
  const toggleAllVisible = () => setSelected(prev => {
    const ns = new Set(prev);
    if (allVisibleSelected) { visibleIds.forEach(id => ns.delete(id)); }
    else { visibleIds.forEach(id => ns.add(id)); }
    return ns;
  });
  const selectedItems = filteredItems.filter(it => selected.has(it.id));

  const exportExcel = () => {
    if (filteredItems.length === 0) { alert("Nessuna richiesta da esportare."); return; }
    const rows = filteredItems.map((it, i) => ({
      "#": i + 1,
      Stato: (STATO_STYLE[it.stato]?.label || it.stato).replace(/^\S+\s/, ""),
      Cognome: it.cognome || "",
      Nome: it.nome || "",
      Classe: it.classe || "",
      Settore: it.settore || "",
      Giorni: it.giorni_label || (it.giorni || []).map(g => GIORNI[g]).join(", "),
      "Ricevuta il": it.created_at ? new Date(it.created_at).toLocaleString("it-IT") : "",
      "Mail inviata il": it.ricevuta_email_at ? new Date(it.ricevuta_email_at).toLocaleString("it-IT") : "",
      "Decisa il": it.decided_at ? new Date(it.decided_at).toLocaleString("it-IT") : "",
      "Decisa da": it.decided_by || "",
      Note: it.nota_studente || "",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Richieste SPOT");
    XLSX.writeFile(wb, `richieste_spot_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const apriDecisione = async (it, esito) => {
    try {
      const r = await api.get(`/mensa-matrice/spot/admin/${it.id}/email-preview`, { params: { esito } });
      setModal({ rid: it.id, item: it, esito, ...r.data, to: r.data.to_default, motivo: "" });
    } catch (e) {
      alert(e.response?.data?.detail || "Errore preview email");
    }
  };

  const elimina = async (it) => {
    const lbl = `${it.cognome} ${it.nome} — ${(it.giorni || []).map(g => GIORNI[g]).join(", ")}`;
    if (!window.confirm(`Eliminare definitivamente la richiesta SPOT di ${lbl}?\n\nL'azione non è reversibile.`)) return;
    try {
      await api.delete(`/mensa-matrice/spot/admin/${it.id}`);
      await load();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore eliminazione");
    }
  };

  return (
    <div data-testid="spot-admin-view" style={{ padding: "12px 18px" }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0, fontSize: 16, color: "#00695c" }}>📋 Richieste mensa SPOT</h2>
        <select value={filterStato} onChange={e => setFilterStato(e.target.value)}
          data-testid="spot-filter-stato"
          style={{ padding: "6px 10px", border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }}>
          <option value="">Tutti gli stati</option>
          <option value="ricevuta">Ricevute</option>
          <option value="accettata">Accettate</option>
          <option value="rifiutata">Rifiutate</option>
        </select>
        <input value={search} onChange={e => setSearch(e.target.value)}
          data-testid="spot-search-alunno" placeholder="🔍 Cerca alunno / classe / cod…"
          style={{ padding: "6px 10px", border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3, width: 240 }} />
        {search && (
          <button onClick={() => setSearch("")} data-testid="spot-search-clear"
            style={{ padding: "6px 10px", background: "#eceff1", color: "#555", border: "1px solid #cfd8dc", fontSize: 11, cursor: "pointer", borderRadius: 3 }}>✕</button>
        )}
        <button onClick={load} data-testid="spot-reload" style={{ padding: "6px 14px", background: "#455a64", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
          🔄 Aggiorna
        </button>
        <button onClick={() => setCreaModalOpen(true)} data-testid="spot-nuova" style={{ padding: "6px 14px", background: "#2e7d32", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
          ➕ Nuova richiesta (per conto alunno)
        </button>
        <button onClick={exportExcel} data-testid="spot-export-excel" title="Esporta in Excel la lista filtrata"
          style={{ padding: "6px 14px", background: "#1b5e20", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
          ⬇ Esporta Excel
        </button>
        <button onClick={() => { if (selected.size === 0) { alert("Seleziona almeno una richiesta (spunta a sinistra)."); return; } setBulkOpen(true); }}
          data-testid="spot-bulk-accetta" title="Accetta le richieste selezionate e invia a ciascuna la mail di accettazione"
          disabled={selected.size === 0}
          style={{ padding: "6px 14px", background: selected.size === 0 ? "#a5d6a7" : "#2e7d32", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: selected.size === 0 ? "not-allowed" : "pointer", borderRadius: 3 }}>
          ✅ Accetta selezionati e invia mail ({selected.size})
        </button>
        <span style={{ color: "#666", fontSize: 12 }}>{filteredItems.length} richiest{filteredItems.length === 1 ? "a" : "e"}{search ? ` (di ${items.length})` : ""}</span>
        <div style={{ display: "flex", gap: 6, marginLeft: 4 }} data-testid="spot-riepilogo-stati">
          <span style={{ background: "#fff8e1", border: "1px solid #ffa726", color: "#bf360c", borderRadius: 10, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>📥 Ricevute: {counts.ricevuta}</span>
          <span style={{ background: "#e8f5e9", border: "1px solid #4caf50", color: "#1b5e20", borderRadius: 10, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>✅ Accettate: {counts.accettata}</span>
          <span style={{ background: "#ffebee", border: "1px solid #ef5350", color: "#b71c1c", borderRadius: 10, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>❌ Rifiutate: {counts.rifiutata}</span>
        </div>
      </div>

      {loading ? <div style={{ color: "#666", padding: 20 }}>Caricamento…</div> : (
        <div style={{ overflowX: "auto" }}>
        <table className="sw-data-table" style={{ width: "100%", background: "white", minWidth: 900 }}>
          <thead>
            <tr style={{ background: "#00695c", color: "white" }}>
              <th style={{ padding: 8, textAlign: "center", width: 34 }}>
                <input type="checkbox" checked={allVisibleSelected} onChange={toggleAllVisible}
                  data-testid="spot-select-all" title="Seleziona/deseleziona tutte le righe visibili"
                  style={{ width: 16, height: 16, cursor: "pointer" }} />
              </th>
              <th style={{ padding: 8, textAlign: "center", width: 40 }}>#</th>
              <th style={{ padding: 8, textAlign: "left", minWidth: 160 }}>Stato</th>
              <th style={{ padding: 8, textAlign: "left" }}>Alunno</th>
              <th style={{ padding: 8, textAlign: "left" }}>Classe</th>
              <th style={{ padding: 8, textAlign: "center" }}>Giorno</th>
              <th style={{ padding: 8, textAlign: "left" }}>Note studente</th>
              <th style={{ padding: 8, textAlign: "left" }}>Date / Stato</th>
              <th style={{ padding: 8, textAlign: "center", minWidth: 330 }}>Azioni / Decisione</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.length === 0 && (
              <tr><td colSpan={9} style={{ padding: 20, textAlign: "center", color: "#999" }}>Nessuna richiesta</td></tr>
            )}
            {filteredItems.map((it, idx) => {
              const st = STATO_STYLE[it.stato] || STATO_STYLE.ricevuta;
              const isSel = selected.has(it.id);
              return (
                <tr key={it.id} data-testid={`spot-row-${it.id}`} style={{ borderBottom: "2px solid #90a4ae", background: isSel ? "#e0f2f1" : undefined }}>
                  <td style={{ padding: 8, textAlign: "center" }}>
                    <input type="checkbox" checked={isSel} onChange={() => toggleSel(it.id)}
                      data-testid={`spot-select-${it.id}`}
                      style={{ width: 16, height: 16, cursor: "pointer" }} />
                  </td>
                  <td style={{ padding: 8, textAlign: "center", fontWeight: 700, color: "#00695c", fontFamily: "monospace" }} data-testid={`spot-row-num-${it.id}`}>{idx + 1}</td>
                  <td style={{ padding: 8 }}>
                    <span data-testid={`spot-row-stato-${it.id}`} style={{ display: "inline-block", padding: "4px 10px", background: st.bg, border: `2px solid ${st.border}`, color: st.color, borderRadius: 12, fontSize: 11, fontWeight: 800, whiteSpace: "nowrap" }}>
                      {st.label}
                    </span>
                  </td>
                  <td style={{ padding: 8 }}>
                    <b>{it.cognome} {it.nome}</b>
                    {it.variata && (
                      <div style={{ margin: "3px 0" }}>
                        <span data-testid={`spot-badge-variata-${it.id}`}
                          title={`Richiesta VARIATA (giorni modificati)${it.giorni_originali ? ` · ${(it.giorni_originali || []).map(g => GIORNI[g]).join(", ")} → ${(it.giorni || []).map(g => GIORNI[g]).join(", ")}` : ""}`}
                          style={{ background: "#e65100", color: "white", fontSize: 9, fontWeight: 800, letterSpacing: 0.5, padding: "2px 7px", borderRadius: 3, whiteSpace: "nowrap", boxShadow: "0 1px 2px rgba(0,0,0,0.2)" }}>
                          🔄 VARIATA
                        </span>
                      </div>
                    )}
                    <div style={{ fontSize: 10, color: "#888" }}>cod. {it.alunno_cod}</div>
                  </td>
                  <td style={{ padding: 8, fontSize: 12 }}>{it.classe}<br/><span style={{ fontSize: 10, color: "#888" }}>{it.settore}</span></td>
                  <td style={{ padding: 8, textAlign: "center", fontWeight: 700, color: "#00695c" }}>
                    {(it.giorni && it.giorni.length > 0)
                      ? it.giorni.map(g => GIORNI[g]).join(", ")
                      : (GIORNI[it.giorno] || it.giorno_label || it.giorni_label || "-")}
                  </td>
                  <td style={{ padding: 8, fontSize: 11, color: "#555", maxWidth: 200 }}>{it.nota_studente || "-"}</td>
                  <td style={{ padding: 8, fontSize: 10, color: "#666", lineHeight: 1.5, whiteSpace: "nowrap" }} data-testid={`spot-date-${it.id}`}>
                    {it.created_at && (
                      <div style={{ color: "#bf360c" }}>📥 Ricevuta il<br/><b>{new Date(it.created_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</b></div>
                    )}
                    {it.ricevuta_email_at && (
                      <div style={{ marginTop: 3, display: "inline-block", background: "#1565c0", color: "white", padding: "2px 6px", borderRadius: 3, fontWeight: 700 }}>📩 Mail inviata il<br/>{new Date(it.ricevuta_email_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</div>
                    )}
                    {it.stato === "accettata" && it.decided_at && (
                      <div style={{ color: "#1b5e20", marginTop: 3 }}>✅ Accettata il<br/><b>{new Date(it.decided_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</b></div>
                    )}
                    {it.stato === "rifiutata" && it.decided_at && (
                      <div style={{ color: "#b71c1c", marginTop: 3 }}>❌ Rifiutata il<br/><b>{new Date(it.decided_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</b></div>
                    )}
                    {!it.created_at && !it.decided_at && "-"}
                  </td>
                  <td style={{ padding: 8, textAlign: "center", whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: 4, alignItems: "center", justifyContent: "center", flexWrap: "nowrap" }}>
                      {it.stato === "ricevuta" ? (
                        <>
                          <button onClick={() => apriDecisione(it, "ricevuta")}
                            data-testid={`spot-ricevuta-${it.id}`}
                            title={it.ricevuta_email_at ? "Mail di ricevuta già inviata — clicca per reinviarla" : "Invia al genitore la mail di ricevuta (richiesta in sospeso)"}
                            style={{ padding: "4px 8px", background: it.ricevuta_email_at ? "#ffe0b2" : "#ef6c00", color: it.ricevuta_email_at ? "#bf6d1a" : "white", border: it.ricevuta_email_at ? "1px solid #ffcc80" : "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                            {it.ricevuta_email_at ? "📩 Ricevuta ✓" : "📩 Ricevuta"}
                          </button>
                          <button onClick={() => apriDecisione(it, "accettata")}
                            data-testid={`spot-accetta-${it.id}`}
                            style={{ padding: "4px 8px", background: "#4caf50", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                            ✓ Accetta
                          </button>
                          <button onClick={() => apriDecisione(it, "rifiutata")}
                            data-testid={`spot-rifiuta-${it.id}`}
                            style={{ padding: "4px 8px", background: "#ef5350", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                            ✕ Rifiuta
                          </button>
                        </>
                      ) : (
                        <>
                          <span style={{ padding: "2px 8px", background: st.bg, border: `1px solid ${st.border}`, color: st.color, borderRadius: 10, fontSize: 10, fontWeight: 700 }}>
                            {st.label}
                          </span>
                          {it.stato === "accettata" && (
                            <button onClick={() => apriDecisione(it, "accettata")}
                              data-testid={`spot-rinvia-accettazione-${it.id}`}
                              title={it.email_inviata_at ? `Mail di accettazione già inviata il ${new Date(it.email_inviata_at).toLocaleString("it-IT")} — clicca per reinviarla` : "Reinvia la mail di accettazione"}
                              style={{ padding: "4px 8px", background: "#00897b", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                              🔄 Rinvia accett.
                            </button>
                          )}
                        </>
                      )}
                      <button onClick={() => setGiorniModal({ it, giorni: new Set(it.giorni || []) })}
                        data-testid={`spot-modifica-giorni-${it.id}`}
                        title="Modifica i giorni della richiesta (effetto immediato sulla matrice)"
                        style={{ padding: "4px 8px", background: "#5e35b1", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                        ✏️ Giorni
                      </button>
                      <button onClick={() => elimina(it)}
                        data-testid={`spot-elimina-${it.id}`}
                        title="Elimina definitivamente questa richiesta"
                        style={{ padding: "4px 8px", background: "#b71c1c", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", borderRadius: 2 }}>
                        🗑 Elimina
                      </button>
                    </div>
                    {it.stato === "ricevuta" && it.ricevuta_email_at && (
                      <div style={{ fontSize: 9, color: "#ef6c00", marginTop: 3 }} data-testid={`spot-ricevuta-sent-${it.id}`}>
                        📩 ricevuta inviata {new Date(it.ricevuta_email_at).toLocaleDateString("it-IT")}
                      </div>
                    )}
                    {it.stato !== "ricevuta" && it.decided_by && (
                      <div style={{ fontSize: 10, color: "#888", marginTop: 3 }}>👤 {it.decided_by}</div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      )}

      {modal && <SpotDecisionModal modal={modal} setModal={setModal} onDone={load} />}
      {bulkOpen && (
        <SpotBulkAccettaModal
          items={selectedItems}
          close={() => setBulkOpen(false)}
          onDone={() => { setSelected(new Set()); load(); }}
        />
      )}
      {creaModalOpen && <SpotCreaManualeModal close={() => setCreaModalOpen(false)} onDone={load} />}
      {giorniModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
          <div data-testid="spot-giorni-modal" style={{ background: "white", borderRadius: 6, width: 480, maxWidth: "92vw", boxShadow: "0 10px 40px rgba(0,0,0,0.4)" }}>
            <div style={{ padding: "12px 16px", background: "#5e35b1", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>✏️ Modifica giorni — {giorniModal.it.cognome} {giorniModal.it.nome}</div>
              <button onClick={() => setGiorniModal(null)} style={{ background: "transparent", border: "none", color: "white", fontSize: 22, cursor: "pointer" }}>×</button>
            </div>
            <div style={{ padding: 18 }}>
              <div style={{ fontSize: 12, color: "#555", marginBottom: 12 }}>Seleziona i giorni della richiesta SPOT. La modifica ha effetto immediato sulla matrice mensa.</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                {[1, 2, 3, 4, 5].map(g => {
                  const on = giorniModal.giorni.has(g);
                  return (
                    <button key={g} data-testid={`spot-giorni-toggle-${g}`}
                      onClick={() => setGiorniModal(m => {
                        const ns = new Set(m.giorni);
                        ns.has(g) ? ns.delete(g) : ns.add(g);
                        return { ...m, giorni: ns };
                      })}
                      style={{ padding: "10px 16px", borderRadius: 6, cursor: "pointer", fontSize: 13, fontWeight: 700,
                        background: on ? "#5e35b1" : "white", color: on ? "white" : "#5e35b1", border: `2px solid ${on ? "#4527a0" : "#5e35b1"}` }}>
                      {GIORNI[g]}
                    </button>
                  );
                })}
              </div>
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <button onClick={() => setGiorniModal(null)} style={{ padding: "8px 18px", background: "white", color: "#555", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>Annulla</button>
                <button onClick={salvaGiorni} data-testid="spot-giorni-salva" style={{ padding: "8px 18px", background: "#4527a0", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: "pointer", borderRadius: 3 }}>💾 Salva giorni</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function SpotCreaManualeModal({ close, onDone }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [alunno, setAlunno] = useState(null);
  const [giorni, setGiorni] = useState([]);
  const [stato, setStato] = useState("ricevuta");
  const [nota, setNota] = useState("");
  const [saving, setSaving] = useState(false);
  const [anni, setAnni] = useState([]);
  const [annoFilter, setAnnoFilter] = useState(null);

  // Carica anni disponibili al mount
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/mensa-matrice/spot/admin/anni-disponibili");
        setAnni(r.data.anni || []);
        if (r.data.anno_default) setAnnoFilter(r.data.anno_default);
      } catch (e) { /* ignore */ }
    })();
  }, []);

  const search = async () => {
    if (q.length < 2) return;
    setSearching(true);
    try {
      const params = { q };
      if (annoFilter) params.anno = annoFilter;
      const r = await api.get("/mensa-matrice/spot/admin/alunni-search", { params });
      setResults(r.data.items || []);
    } catch (e) {
      alert(e.response?.data?.detail || "Errore ricerca");
    } finally { setSearching(false); }
  };

  const submit = async () => {
    if (!alunno || giorni.length === 0) return;
    setSaving(true);
    try {
      const r = await api.post("/mensa-matrice/spot/admin/crea-manuale", {
        alunno_cod: alunno.Cod,
        giorni,
        stato,
        nota,
      });
      const gl = { 1: "Lunedì", 2: "Martedì", 3: "Mercoledì", 4: "Giovedì", 5: "Venerdì" };
      const creati = (r.data?.giorni || []).map((g) => gl[g] || g).join(", ");
      const scartati = (r.data?.scartati || [])
        .map((s) => `${gl[s.giorno] || s.giorno} (${s.dettaglio})`)
        .join(", ");
      let msg = r.data?.merged
        ? `Giorni aggiunti alla richiesta esistente. Ora: ${creati}.`
        : `Richiesta SPOT creata per: ${creati}.`;
      if (scartati) msg += `\n\n⚠ Giorni non considerati (già con mensa): ${scartati}`;
      alert(msg);
      close();
      onDone();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore creazione");
    } finally { setSaving(false); }
  };

  const toggleG = (n) => setGiorni(curr => curr.includes(n) ? curr.filter(x => x !== n) : [...curr, n].sort());
  const giorniLabels = { 1: "Lun", 2: "Mar", 3: "Mer", 4: "Gio", 5: "Ven" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
      <div data-testid="spot-crea-modal" style={{ background: "white", borderRadius: 6, width: 600, maxWidth: "94vw", maxHeight: "90vh", overflow: "auto", boxShadow: "0 10px 40px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "12px 16px", background: "#2e7d32", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>➕ Nuova richiesta SPOT (per conto alunno)</div>
          <button onClick={close} style={{ background: "transparent", border: "none", color: "white", fontSize: 22, cursor: "pointer" }}>×</button>
        </div>
        <div style={{ padding: 18 }}>
          {!alunno ? (
            <>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
                Anno scolastico (filtro alunni)
              </label>
              <select value={annoFilter || ""} onChange={e => setAnnoFilter(e.target.value ? parseInt(e.target.value, 10) : null)}
                data-testid="spot-search-anno"
                style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3, marginBottom: 10 }}>
                <option value="">— Tutti gli anni —</option>
                {anni.map(a => <option key={a} value={a}>{a}/{(a + 1).toString().slice(2)}</option>)}
              </select>

              <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
                Cerca alunno (cognome, nome o codice)
              </label>
              <div style={{ display: "flex", gap: 6 }}>
                <input value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === "Enter" && search()}
                  data-testid="spot-search-alunno"
                  placeholder="Es. FOLEGATI" autoFocus
                  style={{ flex: 1, padding: 8, border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }} />
                <button onClick={search} disabled={q.length < 2 || searching} style={{ padding: "8px 16px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
                  {searching ? "Cerca…" : "🔍 Cerca"}
                </button>
              </div>
              {results.length > 0 && (
                <div style={{ marginTop: 12, border: "1px solid #cfd8dc", borderRadius: 3, maxHeight: 240, overflow: "auto" }}>
                  {results.map(a => (
                    <button key={a.Cod} onClick={() => setAlunno(a)}
                      data-testid={`spot-pick-${a.Cod}`}
                      style={{ display: "block", width: "100%", textAlign: "left", padding: 8, background: "white", border: "none", borderBottom: "1px solid #eee", cursor: "pointer", fontSize: 12 }}>
                      <b>{a.Cog} {a.Nom}</b> <span style={{ color: "#888" }}>(cod. {a.Cod}) — {a.classe || "?"} · {a.settore || "?"}</span>
                    </button>
                  ))}
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ marginBottom: 14, padding: 10, background: "#f5f5f5", borderRadius: 3, fontSize: 12 }}>
                <b>Alunno:</b> {alunno.Cog} {alunno.Nom} (cod. {alunno.Cod}) — {alunno.classe || "?"} · {alunno.settore || "?"}
                <button onClick={() => { setAlunno(null); setResults([]); }} style={{ marginLeft: 8, padding: "2px 8px", background: "transparent", border: "1px solid #888", fontSize: 10, cursor: "pointer", borderRadius: 2 }}>
                  Cambia
                </button>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 6 }}>
                  Giorni settimana (uno o più)
                </label>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 6 }}>
                  {[1,2,3,4,5].map(n => (
                    <button key={n} onClick={() => toggleG(n)}
                      data-testid={`spot-crea-g-${n}`}
                      style={{ padding: "10px 4px", background: giorni.includes(n) ? "#00695c" : "white", color: giorni.includes(n) ? "white" : "#00695c", border: "2px solid #00695c", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 4 }}>
                      {giorniLabels[n]}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
                  Stato iniziale
                </label>
                <select value={stato} onChange={e => setStato(e.target.value)}
                  data-testid="spot-crea-stato"
                  style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }}>
                  <option value="ricevuta">📥 Ricevuta (da verificare)</option>
                  <option value="accettata">✅ Accettata (già confermata)</option>
                </select>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
                  Nota (facoltativa)
                </label>
                <textarea value={nota} onChange={e => setNota(e.target.value)} rows={2} maxLength={500}
                  style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, fontFamily: "inherit", borderRadius: 3 }} />
              </div>
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <button onClick={close} disabled={saving} style={{ padding: "8px 18px", background: "white", color: "#555", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
                  Annulla
                </button>
                <button onClick={submit} disabled={giorni.length === 0 || saving}
                  data-testid="spot-crea-conferma"
                  style={{ padding: "8px 18px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: (giorni.length === 0 || saving) ? "not-allowed" : "pointer", borderRadius: 3, opacity: giorni.length === 0 ? 0.5 : 1 }}>
                  {saving ? "Salvataggio…" : "✓ Crea richiesta"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function SpotDecisionModal({ modal, setModal, onDone }) {
  const [to, setTo] = useState(modal.to);
  const [subject, setSubject] = useState(modal.subject);
  const [body, setBody] = useState(modal.body);
  const [motivo, setMotivo] = useState("");
  const [sending, setSending] = useState(false);
  const isAcc = modal.esito === "accettata";
  const isRic = modal.esito === "ricevuta";
  const isReinvio = isAcc && modal.item?.stato === "accettata";

  // Quando cambia il motivo (per rifiuto), rigenera il body con il placeholder sostituito
  const aggiornaCorpoMotivo = async (newMotivo) => {
    setMotivo(newMotivo);
    if (modal.esito === "rifiutata") {
      try {
        const r = await api.get(`/mensa-matrice/spot/admin/${modal.rid}/email-preview`, { params: { esito: "rifiutata", motivo: newMotivo } });
        setSubject(r.data.subject);
        setBody(r.data.body);
      } catch (e) { /* ignore */ }
    }
  };

  const conferma = async () => {
    setSending(true);
    try {
      if (isRic) {
        const r = await api.post(`/mensa-matrice/spot/admin/${modal.rid}/invia-ricevuta`, { to, subject, body });
        if (r.data.email_ok) alert(`Email di RICEVUTA inviata a ${to}.\nLa richiesta resta in sospeso.`);
        else alert(`Invio email fallito: ${r.data.email_err || "errore sconosciuto"}.`);
      } else {
        const payload = { esito: modal.esito, to, subject, body, motivo };
        const r = await api.post(`/mensa-matrice/spot/admin/${modal.rid}/decidi`, payload);
        if (r.data.email_ok) {
          alert(`Richiesta ${isAcc ? "ACCETTATA" : "RIFIUTATA"} e email inviata a ${to}.`);
        } else {
          alert(`Richiesta ${isAcc ? "ACCETTATA" : "RIFIUTATA"}, ma l'invio email è fallito: ${r.data.email_err || "errore sconosciuto"}.\nLo stato è stato comunque aggiornato.`);
        }
      }
      setModal(null);
      onDone();
    } catch (e) {
      alert(e.response?.data?.detail || "Errore");
    } finally { setSending(false); }
  };

  const hdrBg = isRic ? "#ef6c00" : (isAcc ? "#1b5e20" : "#b71c1c");
  const hdrLabel = isRic ? "📩 INVIA RICEVUTA" : (isReinvio ? "🔄 REINVIA ACCETTAZIONE" : (isAcc ? "✅ ACCETTA" : "❌ RIFIUTA"));
  const btnBg = isRic ? "#ef6c00" : (isAcc ? "#2e7d32" : "#c62828");
  const btnLabel = sending ? "Invio…" : (isRic ? "📩 Invia email ricevuta" : (isReinvio ? "🔄 Reinvia email di accettazione" : (isAcc ? "✓ Accetta e invia email" : "✕ Rifiuta e invia email")));

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
      <div data-testid="spot-modal" style={{ background: "white", borderRadius: 6, width: 720, maxWidth: "94vw", maxHeight: "90vh", overflow: "auto", boxShadow: "0 10px 40px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "12px 16px", background: hdrBg, color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            {hdrLabel} richiesta SPOT — {modal.richiesta.alunno}
          </div>
          <button onClick={() => setModal(null)} style={{ background: "transparent", border: "none", color: "white", fontSize: 22, cursor: "pointer" }}>×</button>
        </div>

        <div style={{ padding: 18 }}>
          <div style={{ fontSize: 12, color: "#555", marginBottom: 10, padding: "8px 12px", background: "#f5f5f5", borderRadius: 3 }}>
            <b>Alunno:</b> {modal.richiesta.alunno} · <b>Classe:</b> {modal.richiesta.classe} · <b>Giorno:</b> {modal.richiesta.giorno}
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
              Email destinatario (modificabile)
            </label>
            <input value={to} onChange={e => setTo(e.target.value)}
              data-testid="spot-modal-to"
              style={{ width: "100%", padding: 8, border: "2px solid #00695c", fontSize: 12, fontFamily: "monospace", borderRadius: 3 }} />
            {modal.to_options && modal.to_options.length > 1 && (
              <div style={{ fontSize: 10, color: "#888", marginTop: 4 }}>
                Altre email disponibili (clicca per usare):
                {modal.to_options.map((opt, i) => (
                  <button key={i} onClick={() => setTo(opt)} style={{ background: "transparent", border: "1px solid #ccc", color: "#1565c0", padding: "2px 6px", fontSize: 10, cursor: "pointer", margin: "0 0 0 4px", borderRadius: 2 }}>
                    {opt}
                  </button>
                ))}
              </div>
            )}
          </div>

          {modal.esito === "rifiutata" && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
                Motivo del rifiuto (inserito al posto di {`{motivo}`} nel corpo email)
              </label>
              <textarea value={motivo} onChange={e => aggiornaCorpoMotivo(e.target.value)} rows={2}
                data-testid="spot-modal-motivo"
                placeholder="Es. Numero massimo posti raggiunto…"
                style={{ width: "100%", padding: 8, border: "1px solid #ef9a9a", fontSize: 12, fontFamily: "inherit", borderRadius: 3 }} />
            </div>
          )}

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Oggetto</label>
            <input value={subject} onChange={e => setSubject(e.target.value)}
              data-testid="spot-modal-subject"
              style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Corpo</label>
            <textarea value={body} onChange={e => setBody(e.target.value)} rows={10}
              data-testid="spot-modal-body"
              style={{ width: "100%", padding: 10, border: "1px solid #cfd8dc", fontSize: 12, fontFamily: "inherit", borderRadius: 3 }} />
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button onClick={() => setModal(null)} disabled={sending}
              style={{ padding: "8px 18px", background: "white", color: "#555", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
              Annulla
            </button>
            <button onClick={conferma} disabled={sending}
              data-testid="spot-modal-conferma"
              style={{ padding: "8px 18px", background: btnBg, color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: sending ? "wait" : "pointer", borderRadius: 3 }}>
              {btnLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


function SpotBulkAccettaModal({ items, close, onDone }) {
  const GIORNI_L = { 1: "Lun", 2: "Mar", 3: "Mer", 4: "Gio", 5: "Ven" };
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [loadingTpl, setLoadingTpl] = useState(true);
  const [testEmail, setTestEmail] = useState("");
  const [testing, setTesting] = useState(false);
  const [testMsg, setTestMsg] = useState(null);
  const [sending, setSending] = useState(false);
  const [report, setReport] = useState(null);

  const sampleId = items.length > 0 ? items[0].id : null;
  const conEmail = items.filter(it => it.alunno_mail_curriculum || it.user_email).length;
  const senzaEmail = items.length - conEmail;

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/mensa-matrice/spot/admin/mail-template", { params: { esito: "accettata" } });
        setSubject(r.data.subject || "");
        setBody(r.data.body || "");
      } catch (e) {
        alert(e.response?.data?.detail || "Errore caricamento template");
      } finally { setLoadingTpl(false); }
    })();
  }, []);

  const inviaProva = async () => {
    if (!testEmail || !testEmail.includes("@")) { setTestMsg({ ok: false, txt: "Inserisci un'email valida per la prova." }); return; }
    setTesting(true); setTestMsg(null);
    try {
      const r = await api.post("/mensa-matrice/spot/admin/invia-prova", { to: testEmail, subject, body, sample_id: sampleId });
      if (r.data.email_ok) setTestMsg({ ok: true, txt: `✅ Email di prova inviata a ${testEmail}.` });
      else setTestMsg({ ok: false, txt: `⚠ Invio fallito: ${r.data.email_err || "errore sconosciuto"}` });
    } catch (e) {
      setTestMsg({ ok: false, txt: e.response?.data?.detail || "Errore invio prova" });
    } finally { setTesting(false); }
  };

  const inviaMassa = async () => {
    if (!window.confirm(`Accettare e inviare la mail di accettazione a ${items.length} richieste selezionate?`)) return;
    setSending(true); setReport(null);
    try {
      const ids = items.map(it => it.id);
      const r = await api.post("/mensa-matrice/spot/admin/decidi-bulk", { ids, subject, body });
      setReport(r.data);
    } catch (e) {
      alert(e.response?.data?.detail || "Errore invio massivo");
    } finally { setSending(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
      <div data-testid="spot-bulk-modal" style={{ background: "white", borderRadius: 6, width: 760, maxWidth: "94vw", maxHeight: "92vh", overflow: "auto", boxShadow: "0 10px 40px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "12px 16px", background: "#1b5e20", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>✅ Accetta & invia mail — {items.length} richieste selezionate</div>
          <button onClick={close} style={{ background: "transparent", border: "none", color: "white", fontSize: 22, cursor: "pointer" }}>×</button>
        </div>

        <div style={{ padding: 18 }}>
          {report ? (
            <div data-testid="spot-bulk-report">
              <div style={{ fontSize: 14, fontWeight: 700, color: "#1b5e20", marginBottom: 10 }}>Invio completato</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                <span style={{ background: "#e8f5e9", border: "1px solid #4caf50", color: "#1b5e20", borderRadius: 10, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>✅ Inviate: {report.inviate}</span>
                <span style={{ background: "#fff3e0", border: "1px solid #ffa726", color: "#bf360c", borderRadius: 10, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>✉️ Senza email: {report.senza_email}</span>
                <span style={{ background: "#ffebee", border: "1px solid #ef5350", color: "#b71c1c", borderRadius: 10, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>⚠ Falliti: {report.falliti}</span>
              </div>
              <div style={{ maxHeight: 260, overflow: "auto", border: "1px solid #eee", borderRadius: 4 }}>
                {(report.results || []).map((res, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "6px 10px", borderBottom: "1px solid #f0f0f0", fontSize: 12 }}>
                    <span><b>{res.alunno || res.id}</b> {res.to ? <span style={{ color: "#888" }}>· {res.to}</span> : null}</span>
                    <span style={{ fontWeight: 700, color: res.status === "sent" ? "#1b5e20" : (res.status === "accepted_no_email" ? "#bf360c" : "#b71c1c") }}>
                      {res.status === "sent" ? "✅ inviata" : res.status === "accepted_no_email" ? "accettata (no email)" : `⚠ ${res.detail || "errore"}`}
                    </span>
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
                <button onClick={() => { onDone(); close(); }} data-testid="spot-bulk-chiudi"
                  style={{ padding: "8px 18px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: "pointer", borderRadius: 3 }}>
                  Chiudi
                </button>
              </div>
            </div>
          ) : loadingTpl ? (
            <div style={{ color: "#666", padding: 20 }}>Caricamento template…</div>
          ) : (
            <>
              <div style={{ fontSize: 12, color: "#555", marginBottom: 12, padding: "8px 12px", background: "#f5f5f5", borderRadius: 3 }}>
                A ogni alunno verrà inviata la mail renderizzata con i propri dati. Alunni selezionati: <b>{items.length}</b> — con email <b>{conEmail}</b>
                {senzaEmail > 0 && <span style={{ color: "#bf360c" }}> · senza email {senzaEmail} (verranno accettati ma senza invio)</span>}.
              </div>
              <div style={{ maxHeight: 90, overflow: "auto", border: "1px solid #eee", borderRadius: 4, marginBottom: 12, padding: "4px 8px", fontSize: 11, color: "#555" }}>
                {items.map(it => (
                  <span key={it.id} style={{ display: "inline-block", background: "#eceff1", borderRadius: 8, padding: "2px 8px", margin: 2 }}>
                    {it.cognome} {it.nome} <span style={{ color: "#888" }}>({(it.giorni || []).map(g => GIORNI_L[g]).join(",")})</span>
                  </span>
                ))}
              </div>

              <div style={{ fontSize: 10, color: "#888", marginBottom: 8 }}>
                Placeholder disponibili: <code>{"{nome}"}</code> <code>{"{cognome}"}</code> <code>{"{classe}"}</code> <code>{"{settore}"}</code> <code>{"{giorno_settimana}"}</code> <code>{"{anno_scol}"}</code>
              </div>

              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Oggetto</label>
                <input value={subject} onChange={e => setSubject(e.target.value)}
                  data-testid="spot-bulk-subject"
                  style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, borderRadius: 3 }} />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>Corpo</label>
                <textarea value={body} onChange={e => setBody(e.target.value)} rows={9}
                  data-testid="spot-bulk-body"
                  style={{ width: "100%", padding: 10, border: "1px solid #cfd8dc", fontSize: 12, fontFamily: "inherit", borderRadius: 3 }} />
              </div>

              <div style={{ background: "#e3f2fd", border: "1px solid #90caf9", borderRadius: 4, padding: 12, marginBottom: 14 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#0d47a1", marginBottom: 6 }}>🧪 Invio di prova (non modifica le richieste)</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <input value={testEmail} onChange={e => setTestEmail(e.target.value)} placeholder="email@esempio.it"
                    data-testid="spot-bulk-test-email"
                    style={{ flex: 1, minWidth: 200, padding: 8, border: "1px solid #90caf9", fontSize: 12, fontFamily: "monospace", borderRadius: 3 }} />
                  <button onClick={inviaProva} disabled={testing}
                    data-testid="spot-bulk-test-send"
                    style={{ padding: "8px 14px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: testing ? "wait" : "pointer", borderRadius: 3 }}>
                    {testing ? "Invio…" : "📤 Invia prova"}
                  </button>
                </div>
                {testMsg && (
                  <div data-testid="spot-bulk-test-msg" style={{ fontSize: 11, marginTop: 6, color: testMsg.ok ? "#1b5e20" : "#b71c1c", fontWeight: 700 }}>{testMsg.txt}</div>
                )}
                <div style={{ fontSize: 10, color: "#555", marginTop: 4 }}>La prova usa i dati del primo alunno selezionato ({items[0]?.cognome} {items[0]?.nome}).</div>
              </div>

              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <button onClick={close} disabled={sending}
                  style={{ padding: "8px 18px", background: "white", color: "#555", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
                  Annulla
                </button>
                <button onClick={inviaMassa} disabled={sending || items.length === 0}
                  data-testid="spot-bulk-conferma"
                  style={{ padding: "8px 18px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: sending ? "wait" : "pointer", borderRadius: 3 }}>
                  {sending ? "Invio in corso…" : `✅ Accetta e invia a ${items.length}`}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
